import React from "react";
import useAuth from "../../contexts/AuthContext";
import useProjectSidebar from "../../hooks/useProjectSidebar";
import ActivatePortfolioCard from "../ui-kit/cards/ActivatePortfolioCard";
import ProBenefitsCard from "../ui-kit/cards/ProBenefitsCard";
import ProjectSidebarCard from "../ui-kit/cards/ProjectSidebarCard";
import Header from "../ui-kit/header/Header";
import LoginArea from "./LoginArea";

const InformationBar = ({ children }: any) => {
  const { projects } = useProjectSidebar();
  const { loggedInUser } = useAuth();

  return (
    <aside
      className="hidden h-full border-l
		border-light-divider 2xl:w-[324px] 2xl:block dark:bg-black-bg  dark:border-dark-divider"
    >
      <div className="h-[4rem] flex items-center justify-end pr-4">
        <LoginArea />
      </div>
      <div className="flex flex-col h-full pl-8">
        {children || (
          <section className="mr-4">
            <div className="mb-4">
              {loggedInUser && loggedInUser.membership?.type === "paid" ? (
                <ActivatePortfolioCard />
              ) : (
                <ProBenefitsCard />
              )}
            </div>

            <Header as="h4" className="mb-2">
              Proyectos Destacados
            </Header>
            <div className="space-y-4">
              {projects.map((project) => (
                <ProjectSidebarCard project={project} key={project.id} />
              ))}
            </div>
          </section>
        )}
      </div>
    </aside>
  );
};

export default InformationBar;
